// Puno ime proizvoda za prikaz. Mnogi product.name već počinju imenom
// brenda/kategorije (npr. "ACE Cool Mint Slim 12mg" za kategoriju "ACE"),
// pa golo `${category_name} ${name}` udvostručava brend ("ACE ACE Cool
// Mint..."). Ova funkcija to izbegava.
export function getProductTitle(categoryName, name) {
  const cat = (categoryName || "").trim();
  const productName = (name || "").trim();
  if (!cat) return productName;
  if (!productName) return cat;
  if (productName.toLowerCase().startsWith(cat.toLowerCase())) {
    return productName;
  }
  return `${cat} ${productName}`;
}
